function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import './file-uploader.scss';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import uploadFiles from '../actions';
var ERROR_TOO_MANY_FILES = 'too-many-files';
var DefaultFileUploadButton = function DefaultFileUploadButton(_ref) {
  var isDragActive = _ref.isDragActive,
    open = _ref.open,
    uploadDisabled = _ref.uploadDisabled;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Select files'),
    className: "btn btn-primary btn-squared ".concat(isDragActive ? 'hovered' : ''),
    onClick: open,
    draggable: true,
    disabled: uploadDisabled,
    type: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Select files"
  }));
};
var FileUploader = function FileUploader(_ref2) {
  var addAcceptedFiles = _ref2.addAcceptedFiles,
    addRejectedFiles = _ref2.addRejectedFiles,
    apiRoot = _ref2.apiRoot,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$dragAndDropEnab = _ref2.dragAndDropEnabled,
    dragAndDropEnabled = _ref2$dragAndDropEnab === void 0 ? true : _ref2$dragAndDropEnab,
    FileUploadButton = _ref2.fileUploadButton,
    fileUploadOptions = _ref2.fileUploadOptions,
    _ref2$maxUploads = _ref2.maxUploads,
    maxUploads = _ref2$maxUploads === void 0 ? 25 : _ref2$maxUploads,
    maxUploadsExceeded = _ref2.maxUploadsExceeded,
    numberOfUploadsRemaining = _ref2.numberOfUploadsRemaining,
    setMaxUploadsExceeded = _ref2.setMaxUploadsExceeded,
    setProgress = _ref2.setProgress,
    _ref2$testAttribute = _ref2.testAttribute,
    testAttribute = _ref2$testAttribute === void 0 ? null : _ref2$testAttribute,
    updateFiles = _ref2.updateFiles;
  var dispatch = useDispatch();
  var onDrop = function onDrop(rawAcceptedFiles, rawRejectedFiles) {
    setProgress(0);

    // Dropzone's default behavior is to fail _all_ files when a user tries
    // to drop more than one file when `multiple` is set to `false`. The below
    // updates this behavior such that we consider those files accepted, but
    // only if they have the correct error message
    var acceptedFiles = rawAcceptedFiles.concat(rawRejectedFiles.filter(function (rejectedFile) {
      return rejectedFile.errors[0].code === ERROR_TOO_MANY_FILES;
    }).map(function (rejectedFile) {
      return rejectedFile.file;
    }));
    var rejectedFiles = rawRejectedFiles.filter(function (rejectedFile) {
      return rejectedFile.errors[0].code !== ERROR_TOO_MANY_FILES;
    });
    if (acceptedFiles.length > numberOfUploadsRemaining) {
      acceptedFiles = acceptedFiles.slice(0, numberOfUploadsRemaining);
      setMaxUploadsExceeded(true);
    }

    // Our upload process does not support:
    // - more than max_file_uploads (20) files at once
    // - a set of files larger than post_max_size (128M)
    // - a single file larger than upload_max_filesize (128M)
    var maxFileUploads = 20;
    var postMaxSize = 128 * 1024 * 1024;
    acceptedFiles = acceptedFiles.filter(function (file) {
      maxFileUploads -= 1;
      postMaxSize -= file.size;
      return maxFileUploads >= 0 && postMaxSize >= 0;
    });
    var addedFiles = addAcceptedFiles(acceptedFiles);
    addRejectedFiles(rejectedFiles);
    return dispatch(uploadFiles(apiRoot, addedFiles, function (progress) {
      return setProgress(progress);
    }, fileUploadOptions.fileUploadQuery)).then(function (_ref3) {
      var acceptedFiles = _ref3.acceptedFiles,
        rejectedFiles = _ref3.rejectedFiles,
        status = _ref3.status;
      updateFiles(acceptedFiles, rejectedFiles, status);
    });
  };
  var uploadDisabled = disabled || maxUploadsExceeded;
  var _useDropzone = useDropzone({
      accept: fileUploadOptions.accept,
      disabled: uploadDisabled,
      fileUploadQuery: fileUploadOptions.fileUploadQuery,
      multiple: fileUploadOptions.multiple,
      onDrop: onDrop,
      noClick: !!FileUploadButton
    }),
    open = _useDropzone.open,
    isDragActive = _useDropzone.isDragActive,
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  var UploadButton = FileUploadButton || DefaultFileUploadButton;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "file-uploader"
  }, /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    "data-cy": testAttribute
  })), /*#__PURE__*/React.createElement(UploadButton, {
    disabled: uploadDisabled,
    isDragActive: isDragActive,
    onClick: open
  }), dragAndDropEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "divider"
  }, /*#__PURE__*/React.createElement(T, {
    source: "or"
  })), /*#__PURE__*/React.createElement("div", {
    draggable: true,
    className: "file-dropper ".concat(isDragActive ? 'hovered' : '')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Drag and drop files here"
  }))) : null), maxUploadsExceeded ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-info mt-4 max-uploads-exceeded-alert"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "max-upload-exceeded-message",
    params: maxUploads
  })) : null));
};
export default FileUploader;